import Button from 'components/base/Button';
import { useCallback, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAppContext } from 'provider/AppProvider/AppProvider';
import defaultImage from 'assets/images/no-picture.png';

interface CardInterface {
  label: string;
  imgSrc: string;
  targetUrl: string;
  subTitle?: string;
}

const Card = (props: CardInterface) => {
  const { label, imgSrc, targetUrl, subTitle } = props;
  const [showFallback, setShowFallback] = useState(false);
  const { fallBackImage } = useAppContext();

  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleClickButton = useCallback(() => {
    if (linkRef.current !== null) linkRef.current.click();
  }, [linkRef]);

  return (
    <div className="w-full flex-col inline-flex gap-6 justify-between items-center">
      <div className="mx-8">
        <div
          style={{ aspectRatio: '9/8' }}
          className="rounded-2xl overflow-hidden"
        >
          <img
            alt={label}
            className="object-contain w-full h-full"
            onError={() => setShowFallback(true)}
            src={showFallback ? fallBackImage || defaultImage : imgSrc}
          />
        </div>
        {Boolean(subTitle) && (
          <div className="mb-3 text-center font-semibold text-gray-400 mt-6">
            {subTitle}
          </div>
        )}
      </div>
      {/* For SEO */}
      <NavLink ref={linkRef} className="hidden" to={targetUrl}>
        {label}
      </NavLink>
      <Button onClick={handleClickButton}>
        <div className="line-clamp-2">{label}</div>
      </Button>
    </div>
  );
};

Card.defaultProps = {
  subTitle: '',
};

export default Card;

/**
 * This component is responsive to its container's size
 */
